import React, { useState, useEffect, useRef, useCallback } from 'react';
import './Header.css';

function Header() {
  const [showCalendly, setShowCalendly] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const menuRef = useRef(null);
  const calendlyRef = useRef(null);

  const toggleCalendly = () => {
    setShowCalendly(!showCalendly);
    setMenuOpen(false); // Close menu when opening Calendly
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // ✅ Wrapped with useCallback to prevent re-creation on every render
  const closeBothIfOpen = useCallback((e) => {
    if (
      ((menuOpen && menuRef.current && !menuRef.current.contains(e.target)) || !menuRef.current) &&
      ((showCalendly && calendlyRef.current && !calendlyRef.current.contains(e.target)) || !calendlyRef.current)
    ) {
      setMenuOpen(false);
      setShowCalendly(false);
    }
  }, [menuOpen, showCalendly]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) setMenuOpen(false);
    };

    window.addEventListener('resize', handleResize);
    document.addEventListener('click', closeBothIfOpen);

    return () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('click', closeBothIfOpen);
    };
  }, [closeBothIfOpen]); // ✅ Now listed in dependency array

  useEffect(() => {
    if (showCalendly) {
      const script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [showCalendly]);

  return (
    <header className="header">
<div className="logo">
  <p onClick={(e) => { 
    e.preventDefault(); 
    setMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' }); 
  }}>
    Aboud Jalal
  </p>
</div>


      {/* Burger Menu Button (Only on Mobile) */}
      {isMobile && (
        <button className="burger-menu" onClick={(e) => { e.stopPropagation(); toggleMenu(); }}>
          {menuOpen ? '⨉' : '☰'}
        </button>
      )}

      {/* Full Menu (Nav + Social Icons) */}
      <div ref={menuRef} className={`menu-container ${menuOpen ? 'open' : ''} ${isMobile ? 'mobile' : ''}`}>
        <div className='menu-nav'>
          <nav className="nav">
          <a href="#home" onClick={(e) => { 
  e.preventDefault(); 
  setMenuOpen(false);
  window.scrollTo({ top: 0, behavior: 'smooth' }); 
}}>Home</a>
            <a href="#about" onClick={() => setMenuOpen(false)}>About</a>
            <a href="#experience" onClick={() => setMenuOpen(false)}>Experience</a>
            <a href="#projects" onClick={() => setMenuOpen(false)}>Projects</a>
          </nav>
        </div>

        {/* Social Icons */}
        <div className="social-icons">
          <button onClick={(e) => { e.stopPropagation(); toggleCalendly(); }} className="calendly-button">
            <img src="/images/calendar.png" className="calendar-icon" alt="Calendar" />
          </button>
          <a href="mailto:aboudjalal1@gmail.com">
            <img src="/images/mail_logo.png" className="mail-icon" alt="Mail" />
          </a>
          <a href="https://www.linkedin.com/in/aboudjalal/" target="_blank" rel="noopener noreferrer">
            <img src="/images/linkedin_logo.png" className="linkedin-icon" alt="LinkedIn" />
          </a>
          <a href="https://github.com/aboudjalal" target="_blank" rel="noopener noreferrer">
            <img src="/images/github_logo.png" className="github-icon" alt="GitHub" />
          </a>
          <a href="#home">
            <img src="/images/resume_logo.png" className="resume-icon" alt="Resume" />
          </a>
        </div>
      </div>

      {/* Calendly Widget */}
      {showCalendly && (
        <div ref={calendlyRef} className="calendly-widget-container">
          <div className="calendly-inline-widget"
            data-url="https://calendly.com/aboudjalal1/one-on-one"
            style={{ width: '100%', height: '100%' }}>
          </div>
          <button className="close-button" onClick={toggleCalendly}>
            Close
          </button>
        </div>
      )}
    </header>
  );
}

export default Header;
